export default "__VITE_ASSET__CBzTch4h__"